import script from "./Live.vue?vue&type=script&lang=ts&setup=true"
export * from "./Live.vue?vue&type=script&lang=ts&setup=true"

import "./Live.vue?vue&type=style&index=0&id=45079235&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45079235"]])

export default __exports__